import React, { useId } from 'react';
const CUSTOMER_LOGO = 'https://cdn.magicpatterns.com/uploads/obgPG9N4gTdC1CM7atXMeZ/Logo.png';
interface BrandLogoProps {
  inverse?: boolean;
  className?: string;
}
export function BrandLogo({
  inverse = false,
  className = ''
}: BrandLogoProps) {
  const filterId = useId().replace(/:/g, '');
  return <span className={`inline-flex items-center justify-center ${inverse ? 'rounded-btn bg-paper px-4 py-3' : ''} ${className}`} aria-label="Separovic Injury Lawyers, established 1990" data-id="element-18" data-mp="1l15z67n391si">
      <svg aria-hidden="true" viewBox="0 0 770 225" role="img" className="h-auto w-[clamp(150px,50vw,250px)] overflow-visible text-ink" preserveAspectRatio="xMidYMid meet" data-id="element-19" data-mp="1urh9cbxd877u">
        <defs data-id="element-20" data-mp="23qvviz6i1vmj">
          <filter id={filterId} x="-5%" y="-5%" width="110%" height="110%" colorInterpolationFilters="sRGB" data-id="element-21" data-mp="edr2ixev34ui">
            <feColorMatrix type="matrix" values="0 0 0 0 0.086  0 0 0 0 0.094  0 0 0 0 0.102  -0.2126 -0.7152 -0.0722 1 0" data-id="element-22" data-mp="15590f411gpsb" />
          </filter>
        </defs>

        <image href={CUSTOMER_LOGO} x="-140" y="-54" width="1050" height="300" preserveAspectRatio="xMidYMid meet" filter={`url(#${filterId})`} data-id="element-23" data-mp="1e5yspxr3by1a" />

        <text x="385" y="218" textAnchor="middle" fill="currentColor" stroke="currentColor" strokeWidth="0.34" paintOrder="stroke fill" fontFamily="Cinzel, 'Times New Roman', serif" fontSize="30" fontWeight="700" letterSpacing="4" data-id="element-24" data-mp="1nw9xfmilmb98">
          EST. 1990
        </text>
      </svg>
    </span>;
}